<h2 mat-dialog-title>Neues Modul anlegen</h2>

<div class="pixl-form">
    <mat-dialog-content [formGroup]="form" class="grid">

        <mat-form-field class="full-width">
            <mat-label>Title</mat-label>
            <input matInput formControlName="title" />
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status">
                <mat-option value="Edit">Edit</mat-option>
                <mat-option value="Live">Live</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Pre-Title</mat-label>
            <input matInput formControlName="preTitle" />
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description"></textarea>
        </mat-form-field>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">
            Speichern
        </button>
    </mat-dialog-actions>
</div>